/* eslint-disable rover/no-platform-specific-globals-or-imports */
import { Logger } from '@rover/rsdk/src/modules/Logging';

const setAmplitudeUserProperties = (userProperties, userOpk?: string): void => {
  if (typeof window !== 'object') return;
  if (window.eventstream?.amplitudeConfigure) {
    window.eventstream.amplitudeConfigure(userOpk, userProperties, {});
  } else {
    Logger.warn('Amplitude not available to update User Properties', {
      userOpk: userOpk ?? '',
      userProperties,
    });
  }
};

export default setAmplitudeUserProperties;
